
import { useNavigate } from "react-router-dom";
import TopicCard from "./TopicCard";
import { FaPlus } from "react-icons/fa";
import AuthContext from "../../../auth/AuthContext";
import { useContext, useEffect, useState } from "react";

const Topics= () => {
  const navigate = useNavigate()
  const authContext = useContext(AuthContext);
   const [permissions, setPermissions] = useState({});
 
     useEffect(() => {
     const topicAccess = authContext.getPermissions('knowledgemanagement');
     if (topicAccess.filter((f) => f.access.includes(1)).length === 0) {
       navigate('/');
     }
     setPermissions({
       showAdd: topicAccess.some((f) => f.access.includes(2)),
       showEdit: topicAccess.some((f) => f.access.includes(3)),
       showDelete: topicAccess.some((f) => f.access.includes(4)),
     });
   }, [authContext, navigate]);

  return (
    <div className="w-full mt-4">
              {permissions.showAdd && (
              <div className="flex justify-end mb-6 gap-3">
                <button
                  onClick={() => navigate("/knowledge-management/topics/add")}
                  className="flex items-center gap-2 px-4 py-2 rounded-md
                             bg-[#0e3a46] hover:bg-[#0c313b]
                             text-white text-sm font-medium transition"
                >
                  <FaPlus size={14} />
                  Create Topic
                </button>
        
                <button
                  onClick={() => navigate("/knowledge-management/topics/add-sub-topic")}
                  className="flex items-center gap-2 px-4 py-2 rounded-md
                             bg-[#0e3a46] hover:bg-[#0c313b]
                             text-white text-sm font-medium transition"
                >
                  <FaPlus size={14} />
                  Create Sub Topic
                </button>
              </div>
              )}

      {/* Topic Cards */}
   <div
  className="
    grid gap-6
    grid-cols-1
    sm:grid-cols-2
    md:grid-cols-2
    lg:grid-cols-3
    xl:grid-cols-4   
  "
>
     
          <TopicCard />
      </div>
    </div>
  );
};

export default Topics;